import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { Box } from '@cp/ds/src/components/box';
import { Container } from '@cp/ds/src/components/container';
import { Stack } from '@cp/ds/src/components/stack';
import { Trademark } from '@cp/ds/src/components/trademark';
import { Typography } from '@cp/ds/src/components/typography';
import { WithUpperline } from '@cp/ds/src/components/withUpperline';
import { SxProps } from '@mui/material';
import React from 'react';
import { MapWithLinksRegions, MapWithLinksRegionsProps } from 'src/app/shared/components/mapWithLinksRegions';
import BackgroundEllipsesSvg from '../../../../assets/shapes/homeIntroSectionBackground.svg';

export const GeographyOfPresence: React.FC<
  {
    disableBackgroundEllipses?: boolean;
    sxContainerProps?: SxProps;
    disableTrademarkShow?: boolean;
  } & MapWithLinksRegionsProps
> = ({ disableBackgroundEllipses, sxContainerProps, disableTrademarkShow, ...restProps }) => {
  const isMobile = useIsMobile();
  return (
    <Box
      sx={{
        position: 'relative',
        backgroundColor: disableBackgroundEllipses ? 'background.default' : 'background.paper',
        overflow: 'hidden',
      }}
    >
      {!disableBackgroundEllipses && !isMobile && (
        <BackgroundEllipsesSvg style={{ position: 'absolute', top: 0, height: 'auto', width: '170%', marginLeft: '-25%' }} />
      )}
      <Container>
        <Stack sx={sxContainerProps}>
          <WithUpperline sx={{ mb: { xs: 1, md: 3 } }}>
            <Typography
              component="h2"
              sx={{
                typography: { xs: 'h5', sm: 'h4', md: 'h2' },
                m: 0,
                mb: 2.75,
              }}
            >
              География присутствия
              <Typography
                component="span"
                sx={{
                  typography: { xs: 'h5', sm: 'h4', md: 'h2' },
                }}
              >
                {' '}
                на карте
              </Typography>
            </Typography>
          </WithUpperline>
          <Typography
            sx={{
              zIndex: 1,
              typography: { xs: 'caption bold', md: 'body' },
              color: { xs: 'gray', md: 'brand gray' },
              mb: { xs: 1, md: 3 },
            }}
          >
            YouHelp сегодня в 162 городах России
          </Typography>
          {!disableTrademarkShow && <Trademark size={3.3} />}
          <MapWithLinksRegions {...restProps} />
        </Stack>
      </Container>
    </Box>
  );
};
